import { endOfDay, endOfMonth, endOfYear, isBefore, startOfDay, startOfMonth } from 'date-fns';
import { DateObject } from 'react-multi-date-picker';

import { DatePeriod } from '../types/date-period';

export const formatDateRangeValues = (dateRange: DateObject[], period: DatePeriod) => {
  const firstDate = dateRange[0]?.format?.('MM/DD/YYYY');

  const secondDate = dateRange[1]?.format?.('MM/DD/YYYY');

  const fromDate = isBefore(firstDate, secondDate) ? firstDate : secondDate;

  const toDate = isBefore(firstDate, secondDate) ? secondDate : firstDate;

  switch (period) {
    case DatePeriod.DAY:
      return { from: startOfDay(fromDate), to: endOfDay(toDate) };
    case DatePeriod.MONTH:
      return { from: startOfMonth(fromDate), to: endOfMonth(toDate) };
    case DatePeriod.YEAR:
      return { from: startOfMonth(fromDate), to: endOfYear(toDate) };
  }
};
